import { createContext, useContext, useState } from "react";

/**
 * Holds the sign-up details in memory so the payment page can read them.
 * Intentionally not persisted — refreshing the payment page sends the user
 * back to sign up (see PaymentPage).
 *
 * Shape: { name: string, email: string, amount: number } | null
 */
const OrderContext = createContext(null);

export function OrderProvider({ children }) {
  const [order, setOrder] = useState(null);

  return (
    <OrderContext.Provider value={{ order, setOrder }}>
      {children}
    </OrderContext.Provider>
  );
}

export function useOrder() {
  const ctx = useContext(OrderContext);
  if (!ctx) {
    throw new Error("useOrder must be used within an OrderProvider");
  }
  return ctx;
}
